// Simple phone outline SVG for use in the ReviewSlide component
export const phoneOutlineSvg = `
<svg width="100%" height="100%" viewBox="0 0 300 600" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="phoneGradient" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#2d3748;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#1a202c;stop-opacity:1" />
    </linearGradient>
  </defs>
  <rect x="20" y="20" width="260" height="560" rx="30" ry="30" fill="url(#phoneGradient)" stroke="#4a5568" stroke-width="2" />
  <rect x="40" y="60" width="220" height="440" rx="2" ry="2" fill="#1a202c" stroke="#4a5568" stroke-width="1" />
  <circle cx="150" cy="520" r="20" fill="#2d3748" stroke="#4a5568" stroke-width="1" />
  <rect x="115" y="35" width="70" height="10" rx="5" ry="5" fill="#2d3748" />
</svg>
`; 